import React, { lazy, Suspense } from 'react';

const LazyOrderHistoryDisplays = lazy(() => import('./OrderHistoryDisplays'));

const OrderHistoryDisplays = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyOrderHistoryDisplays {...props} />
  </Suspense>
);

export default OrderHistoryDisplays;
